/**
 * Map name for mutations
 * @types {string}
 */

export const SET_PARTNER = "PARTNER/SET_PARTNER";
export const SET_PARAMETERS = "PARTNER/SET_PARAMETERS";
export const SET_CUSTOMER_SERVICE = "PARTNER/SET_CUSTOMER_SERVICE";
/**
 * TODO: https://app.clickup.com/t/868ck271k
 */
export const SET_USE_CUSTOM_LOGO = "PARTNER/SET_USE_CUSTOM_LOGO";
export const SET_COMMISSION_PERCENT = "PARTNER/SET_COMMISSION_PERCENT"
